<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M20.488,3.515a11.994,11.994,0,1,0,0,16.97A12.014,12.014,0,0,0,20.488,3.515ZM16.709,15.279A1,1,0,0,1,15.3,16.694l-3.11-3.11a.252.252,0,0,0-.354,0l-3.109,3.11a1.019,1.019,0,0,1-1.415,0,1,1,0,0,1,0-1.415l3.11-3.109a.249.249,0,0,0,0-.353l-3.11-3.11A1,1,0,0,1,8.722,7.292l3.109,3.11a.25.25,0,0,0,.354,0l3.11-3.11a1,1,0,0,1,1.414,1.415l-3.11,3.11a.25.25,0,0,0,0,.353Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'delete-2',
    },
    name: {
      type: String,
      required: false,
      default: 'Delete2',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>